import React, { useState } from 'react';
import styled from 'styled-components';
import { MMFlag, Flag, ENGFlag, WhiteDropdown } from "@assets";
import {
  ENGLISH_LANGUAGE_CODE_LK,
  BURMESE_LANGUAGE_CODE_LK,
  CHINESE_LANGUAGE_CODE_LK,
} from "@constants";
import { localStorage } from "@utils";
import { useTranslation } from "react-i18next";
import LanguageModal from '../LanguageModal/LanguageModal';

const Button = styled.div`
  padding: 6px 10px;
  border-radius: 20px;
  background: #D66700;
  backdrop-filter: blur(25px);

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;

  color: #FFF;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
`

const Img = styled.img`
  width: 20px;
  height: 20px;
`

const LanguageBtn = () => {
  const userPreferedLanguage = localStorage.getUserPreferedLanguage();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const languages = [
    {
      id: CHINESE_LANGUAGE_CODE_LK,
      img: Flag,
      label: t("common.chinese"),
    },
    {
      id: ENGLISH_LANGUAGE_CODE_LK,
      img: ENGFlag,
      label: t("common.english"),
    },
    {
      id: BURMESE_LANGUAGE_CODE_LK,
      img: MMFlag,
      label: t("common.burmese"),
    },
  ];

  const selectedLanguage = languages.filter((item) => item.id === userPreferedLanguage)[0];

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
      >
        <Img
          src={selectedLanguage?.img || languages[1].img}
          alt='flag'
        />
        {selectedLanguage?.label || languages[1].label}
        <WhiteDropdown style={{width: 20}} />
      </Button >
      <LanguageModal
        open={open}
        handleClose={() => setOpen(false)}
      />
    </>

  )
}

export default LanguageBtn